export default __webpack_public_path__ + "static/helvetica-967c07100e27e9f1d9c6c9b1172e34d8.woff";